import request from "root/js/request";

export const postSyncTypes = async ({ CABINET_ID, sync_types, } = {}) => {
  const response = await request({
    url: `company/mp_cabinets/${CABINET_ID}/execute_by_sync_type/`,
    method: "post",
    data: {
      sync_types,
    },
  });
  return response.data;
};
